module.exports = __webpack_public_path__ + "static/media/favicon.fd50094b.ico";